import { render, staticRenderFns } from "./DkoStatusCard.vue?vue&type=template&id=41c9bd72&scoped=true"
import script from "./DkoStatusCard.vue?vue&type=script&lang=js"
export * from "./DkoStatusCard.vue?vue&type=script&lang=js"
import style0 from "./DkoStatusCard.vue?vue&type=style&index=0&id=41c9bd72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9bd72",
  null
  
)

export default component.exports